export const switchStyles = (theme) => ({
  formControlLabel: {
    display: theme.wrappers.display.flex,
    justifyContent: theme.wrappers.justifyContent.spaceBetween,
    width: theme.wrappers.fullWidth,
  },
});
